/* Stylesheet */

.current_data_handler {
  height: 100%;
}

.no_data_container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;

  .label {
    font-size: 1.313rem;
    font-weight: bolder;
    color: #d2dce9;
  }
}
